import React from 'react'
import PropTypes from 'prop-types'
import FormField from 'kepler/lib/components/FormField'
import cs from 'classnames'
import styles from './formField.module.css'

const FormFieldWrapper = ({ centerContents, className, ...rest }) => (
  <FormField
    className={cs(
      styles.container,
      centerContents && styles.centerContents,
      className,
    )}
    {...rest}
  />
)

FormFieldWrapper.propTypes = {
  centerContents: PropTypes.bool,
  className: PropTypes.string,
}

export default FormFieldWrapper
